<div class="container-fluid d-flex align-items-center h-100 justify-content-center gradient-bg">
  <div class="ml-3 mr-3 card rounded bg-lightgrey p-3 login-box">
    <div class="row p-4">
      <img src="../../../assets/images/logo-clearramp-dark.png" class="pt-1 pb-1 pr-3 pl-3 w-100 center mx-auto">
    </div>
    <div class="row">
      <form class="mx-auto w-100 pl-4 pr-4">
        <p class="text-center" *ngIf="!showconfirmation">Confirm Registration</p>
        <p class="text-center" *ngIf="showconfirmation">Registration Succesfull</p>
        <div *ngIf="errorMessage!=null" class="alert alert-danger">
          {{ errorMessage | trans }}
      </div>
      <div *ngIf="showconfirmation" class="alert alert-success ml-3 mr-3 w-100" role="alert">
        Your account has been created
      </div>
    <div class="form-group" *ngIf="email===null">
                    <label class="mb-0 f-13 font-weight-light" for="confirmationCode">Email</label>
                    <input id="email" type="email" maxlength="50" class="form-control"
                           [(ngModel)]="email" [ngModelOptions]="{standalone: true}">
                </div>
                <div *ngIf="!showconfirmation" class="form-group">
                    <label class="mb-0 f-13 font-weight-light" for="confirmationCode">Confirmation Code</label>
                    <input id="confirmationCode" type="text" maxlength="50" class="form-control"
                           [(ngModel)]="confirmationCode" [ngModelOptions]="{standalone: true}">
                </div>
                <div *ngIf="showconfirmation" class="form-group">
                   <h6 class="succes-msg">Press the button below to navigate back to the login page.</h6>
              </div>
                <div class="form-group">
                    <button *ngIf="!showconfirmation" (click)="onConfirmRegistration()" id="confirmRegistration" type="submit"
                            class="btn button-animation btn-animate w-100"><span>Confirm</span>
                    </button>
                    <button *ngIf="showconfirmation" (click)="ConfirmationAccept()" id="confirmRegistration" type="submit"
                    class="btn button-animation btn-animate w-100"><span>Understood</span>
            </button>
                </div>
                <p class="h-50px text-muted text-center op-05 center mb-3 mt-3 f-12 opacity-reverse cursor-pointer">Can't find your code?  
                  <a [routerLink]="['/resendCode']"> <i class="fa fa-fw fa-group"></i> Resend Code</a>
                    <a [routerLink]="['/login']"> <i class="fa fa-fw fa-user"></i> Login</a>
                </p> <p class="mt-2 h-50px text-muted text-center op-05 center"> © ClearRamp - Eagleox Technologies ApS {{ year }}</p>
      </form>
  </div>
</div>
</div>
